export const appointmentStatus: {
  [key: number]: string;
} = {
  0: 'Non confermato',
  1: 'Confermato',
  2: 'Cliente arrivato',
  3: 'Cliente non arrivato',
  4: 'Visita completata',
};
